module.exports = "/static-assets/_next/static/images/seagullLoadingGif-a543c301ba1b87044ed2c1c1c4801ffa.gif";